import { useMemo } from 'react';

import { grey3 } from 'approot/shared/styles/colours.style';
import { useRegionData } from 'approot/shared/region/region.apollo';
import {
  formatSubjectCurriculums,
  hasAllCurriculums,
  removeDuplicateCurriculums,
} from 'approot/shared/curriculum-tags/curriculum-tags.utils';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import {
  CurriculumFragment,
  CurriculumUnitFragment,
} from 'approot/shared/curriculum-tags/curriculum-tags.constants';
import { AU, CurriculumOption } from 'global/constants';

export const CurriculumTags = ({
  outcomes,
}: {
  outcomes: CurriculumUnitFragment | null;
}) => {
  const { isRegionAU } = useRegionData();

  const sortedOutcomes = useMemo(() => {
    if (!outcomes) {
      return [];
    }

    return [...outcomes].sort((a, b) =>
      a.curriculum.localeCompare(b.curriculum)
    );
  }, [outcomes]);

  if (!isRegionAU || !outcomes) {
    return null;
  }

  return hasAllCurriculums(sortedOutcomes) ? (
    <BadgeSmallStyled data-selector="curriculum-pill" $colour={grey3}>
      All Curriculums
    </BadgeSmallStyled>
  ) : (
    <>
      {sortedOutcomes.map(outcome => {
        const outcomeLabel =
          outcome.curriculum === AU ? 'AUS' : outcome.curriculum;
        return (
          <BadgeSmallStyled
            data-selector="curriculum-pill"
            key={outcome.curriculum}
            $colour={grey3}
          >
            {outcomeLabel}
          </BadgeSmallStyled>
        );
      })}
    </>
  );
};

export const CurriculumLessonTags = ({
  outcomes,
}: {
  outcomes: CurriculumFragment | null;
}) => {
  if (!outcomes) return null;

  const simplifiedOutcomes = removeDuplicateCurriculums(outcomes);

  return <CurriculumTags outcomes={simplifiedOutcomes} />;
};

export const CurriculumSubjectTags = ({
  outcomes,
}: {
  outcomes: CurriculumOption[] | null;
}) => {
  if (!outcomes) return null;

  const simplifiedOutcomes = formatSubjectCurriculums(outcomes);

  return <CurriculumTags outcomes={simplifiedOutcomes} />;
};
